// extracted by css-extract-rspack-plugin
export default {"testGeo":"testGeo__Q6vgd","testGeo__map":"testGeo__map__Nfqxy","testGeo__footer":"testGeo__footer__DIyVc","testGeo__button":"testGeo__button__Rb4lJ"};